import { Directive, EventEmitter, Input, type OnInit, Output, inject } from '@angular/core';
import { ScrollIntoViewControl } from './scroll-into-view.control';

@Directive({
  selector: '[rcpScrollIntoView]',
  providers: [ScrollIntoViewControl],
})
export class ScrollIntoViewDirective implements OnInit {
  private scrollIntoViewControl = inject(ScrollIntoViewControl);

  @Input() persistant: boolean;

  @Output() scrollIntoView = new EventEmitter<void>();

  ngOnInit() {
    this.scrollIntoViewControl.onScrollIntoView(this.persistant).subscribe(() => {
      this.scrollIntoView.emit();
    });
  }
}
